import React, { useEffect, useState } from "react";
import { Button, Layout, Space, Table, Tag, Typography, Alert, Row, Input, Col, Modal, Form, Card, Divider } from 'antd';
import { EyeOutlined, PrinterOutlined, CaretLeftOutlined, CaretRightOutlined, LockOutlined, DeleteOutlined, CloseOutlined, WalletOutlined, EditOutlined } from '@ant-design/icons';
import { Link, useNavigate } from "react-router-dom";
import { inject, observer } from 'mobx-react'
import { cloneDeep } from "lodash";
import "./style.scss";
import Swal from "sweetalert2";
import jsPDF from 'jspdf';
import QRCode from 'qrcode';

const { Content } = Layout;
const { Title, Text } = Typography;
const { Search } = Input;

const AuditTrails = ({ reportStore }) => {

  const navigate = useNavigate()
  const [form] = Form.useForm();

  const [isEditTeamLeader, setIsEditTeamLeader] = useState(false);
  const [editableTeamLeader, setEditableTeamLeader] = useState();
  const [userType, setUserType] = useState("TEAM_LEADER");

  useEffect(() => {
    reportStore.page = 1;
    reportStore.hasMore = false;
    reportStore.perPage = 20;
    reportStore.fetchAuditTrails();
  }, []);


  const handlePrevPage = () => {
    reportStore.page = reportStore.page - 1;
    reportStore.fetchAuditTrails();
  };

  const handleNextPage = () => {
    reportStore.page = reportStore.page + 1;
    reportStore.fetchAuditTrails();
  };

  const columns = [
    {
      title: 'Description',
      key: 'Description+ID',
      dataIndex: 'Description',
      render: (Description) => (
        <Text strong>{Description ?? "-"}</Text>
      )
    },
    {
      title: 'Name',
      key: 'Name+ID',
      dataIndex: 'Name',
      render: (Name) => (
        <Text default>{Name}</Text>
      )
    },
    {
      title: 'Username',
      key: 'Username+ID',
      dataIndex: 'Username',
      render: (Username) => (
        <Text default>{Username ?? "-"}</Text>
      )
    },
    {
      title: 'User Type',
      key: 'UserType+ID',
      dataIndex: 'UserType',
      render: (UserType) => (
        <Text default>{UserType}</Text>
      )
    }
  ];

  return (
    <div className="admin-list-team-leader">
      <Content>
        <div className="admin-content-team-leader">
          <Row justify={"space-between"} align={"middle"}>
            <Col>
              <Title level={4}>Audit Trails (User Activities and Logs)</Title>
            </Col>
          </Row>
          <Alert
            message="Audit Trails"
            description="Audit trails track all user activities and system changes to ensure transparency and security. They help monitor actions, detect anomalies, and maintain compliance."
            type="info"
            showIcon
          />
          <div className="web-data">
            <Table pagination={false} columns={columns} dataSource={cloneDeep(reportStore.audittrails)} bordered/>
          </div>
          <ul className="pagination">
            <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={reportStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
            <li className="pagination-item"><a>{reportStore.page}</a></li>
            <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={reportStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
          </ul>
          <Divider/>
        </div>
      </Content>
    </div>

  );
};

export default inject('reportStore')(observer(AuditTrails));
